/**
 * @owner @Appboy/frontend-ix
 * @fileoverview GET handler for the "/dust/auth/:app_group_id" endpoint
 */

import type { DustConfigResponse } from "@lib/dust";
import fetch, { encodeParams } from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";

export const getDustConfig = reactQueryFetcherAdapter(
  cacheKey,
  (signal: AbortSignal, appGroupId: string): Promise<DustConfigResponse> => {
    // The deployed SharedWorker bundle hash (injected into the page config at
    // load time) is salted into the MITE backend-side, so shipping new worker
    // code hands freshly-loaded tabs a fresh DUST session. Omitted when the hash
    // is unavailable (e.g. local dev before the bundle is built), in which case
    // the backend falls back to the legacy MITE.
    const sharedWorkerHash = window.brazeDashboardConfig?.dustSharedWorkerHash;
    const query = sharedWorkerHash ? `?${encodeParams({ version: sharedWorkerHash })}` : "";
    const url = `/dust/auth/${appGroupId}${query}`;
    return fetch(url, "GET", undefined, { signal });
  }
);
